import { PromotionWithTracking } from "./async-promotion-response";
import { getPlaceholderUrl } from "../../utils/getPlaceholderUrl";

export function template(promotion: PromotionWithTracking): string {
    const { image } = promotion.transformedProperties;
    return (
        `
    <div class="block block-hero">

        <div class="block-image">
            <picture>
                <source
                    media="(max-width: 567px)"
                    data-srcset="${image["567x266"]} ${
            image["1134x532"] !== "undefined"
                ? `, ${image["1134x532"]} 2x `
                : ""
        }"
                    class="ux-slider-lazy-img"
                />
                <source
                    media="(max-width: 1024px)"
                    data-srcset="${image["1024x482"]} ${
            image["2048x964"] !== "undefined"
                ? `, ${image["2048x964"]} 2x `
                : ""
        }"
                    class="ux-slider-lazy-img"
                />
                <source
                    data-srcset="${image["1440x678"]} ${
            image["2880x1356"] !== "undefined"
                ? `, ${image["2880x1356"]} 2x `
                : ""
        }"
                    class="ux-slider-lazy-img"
                />
                <img
                    class="ux-slider-lazy-img"
                    data-src="${image["1440x678"]}"
                    alt="landscape-16x9 - 16x9 Image"
                    src="${image["1440x678"]}"
                />
            </picture>
        </div>` +
        (promotion.teaser !== ""
            ? `<div class="stoerer-circle">
                <div class="stoerer-circle-content">
                    <span class="title-normal">
                        ${promotion.teaser}
                    </span>
                </div>
            </div>`
            : "") +
        `
        <div class="block-content">
            <span class="ux-text-small ux-text-small--bold">
                ${promotion.subHeadline}
            </span>
            <h2 class="headline-big">
            ${promotion.headline || ""}
            </h2>
            <div class="block-content-text">
                <div class="text-normal">
                    <p>
                    ${promotion.bodytext || ""}
                    </p>
                </div>
            </div>
            <div class="block-button">
                <a href="${
                    promotion.linkUrl || ""
                }" class="btn js-ux-async-promotion-tracking" data-tracking='${JSON.stringify(
            promotion.tracking
        )}'>${promotion.linkLabel || ""}</a>
            </div>
            <div class="ux-slider-inline-pagination-anchor"></div>

        </div>
    </div>
    `
    );
}

export function renderLoadingSlideContent() {
    return `
    <div class="block block-hero">
    <div class="block-image">
        <picture>
            <img
                class="ux-slider-lazy-img"
                src="${getPlaceholderUrl(1440, 678)}"
            />
        </picture>
    </div>
    <div class="block-content">
        <ux-loader variant="spinner"></ux-loader>
        <div class="ux-slider-inline-pagination-anchor"></div>
    </div>
</div>
    `;
}
